import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddressUtil } from 'src/app/helpers/utils/address.util';
import { CitiesResponse } from 'src/app/shared/interfaces/address';
import { AppConfigService } from 'src/environments/app-config.service';
import { catchError, first, Observable, throwError } from 'rxjs';
import { HandleErrorService } from '../handle-error/handle-error.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private static readonly ALLOWED_UF = new Set(
    new AddressUtil().estadosBrasil.map(estado => estado.inputId)
  );

  private environment: any
  private apiUrl: string;
  
  constructor(
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private appConfig: AppConfigService,
    private handleErrorService: HandleErrorService
  ) {
    this.environment = this.appConfig.config;
    this.apiUrl = `${this.environment.apiIssuer}/nome`
  }

  public getCitiesByAbbreviation(abbreviation: string): Observable<CitiesResponse> {
    const uf = this.normalizeBrazilianUf(abbreviation);
    if (!uf) {
      return throwError(() => new Error('Invalid Brazilian state abbreviation'));
    }

    const params = new HttpParams().set('stateAbbreviation', uf);
    const citiesUrl = `${this.apiUrl}/cities/find-by-state-abbreviations`;

    return this.httpClient.get<CitiesResponse>(citiesUrl, { params }).pipe(
      first(),
      catchError(err => {      
        return this.handleErrorService.handleError(err)
      })
    );
  }

  private normalizeBrazilianUf(abbreviation: string): string | null {
    const uf = (abbreviation ?? '').trim().toUpperCase();
    return AddressService.ALLOWED_UF.has(uf) ? uf : null;
  }
}
